import { faCreditCard, faMoneyBillWave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Card, Typography } from "@material-ui/core";
import { COLORS } from "config/theme";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { ScalingX } from "shared/network/scaling-x.api";
import { ScalingY } from "shared/network/scaling-y.api";
import { BaseCurrency, CompanySite, Contract, Item, ItemPackaging, Offer } from "shared/types";

export type OrderFormValues = {
  id: undefined;
  isWithoutPrice: boolean;
  order: {
    isPaid: boolean;
    deliveryName: string;
    deliveryComment: string;
    deliveryFrom: Date | null;
    currency: BaseCurrency;
    orderName: string;
    isOneItem: boolean;
  };
  company: any; //Company | null;
  companySite: CompanySite | null;
  offer: Offer | null;
  contract: Contract | null;
  project: any; //Project | null;
  relOrderItem: any[]; //OrderItemEntry[];
  fullNetPrice: string;
  fullGrossPrice: string;
  paymentType: string;
  showComment: boolean;
  showPackageSize: boolean;
};

export type OrderItemEntry = {
  id?: string;
  quantity: string;
  price: string;
  netPrice: string;
  tax: string;
  amountType: ItemPackaging | null;
  item: Item;
  serialNumber?: string;
  scalingX?: ScalingX;
  scalingY?: ScalingY;
  discount?: number;
  description?: string;
};

type Props = {
  paymentType: "CARD" | "CASH";
  setPaymentType: Dispatch<SetStateAction<"CARD" | "CASH">>;
};
const SellingPaymentType = ({ paymentType, setPaymentType }: Props) => {
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexWrap="wrap"
      width="100%"
      gridGap={12} // Csökkentett távolság a gombok között
      mt={2}
    >
      <Card
        style={{
          padding: 8,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          gridGap: 8,
          border:
            paymentType === "CASH" ? `2.5px solid ${COLORS.main}` : `1px solid ${COLORS.lightGrey}`,
          boxShadow: paymentType === "CASH" ? "0px 6px 18px rgba(25, 118, 210, 0.18)" : "none",
          background: paymentType === "CASH" ? "#e3f2fd" : "#fff",
          color: COLORS.main,
          transition: "all 0.2s",
          scale: paymentType === "CASH" ? "1.1" : "0.9",
        }}
        onClick={() => setPaymentType("CASH")}
      >
        <FontAwesomeIcon icon={faMoneyBillWave} style={{ fontSize: "20px", color: COLORS.main }} />
        <Typography style={{ fontWeight: "bold", fontSize: "15px" }}>
          {t("invoice.formValues.paymentType.CASH")}
        </Typography>
      </Card>
      <Card
        style={{
          padding: 8,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          gridGap: 8,
          border:
            paymentType === "CARD" ? `2.5px solid ${COLORS.main}` : `1px solid ${COLORS.lightGrey}`,
          boxShadow: paymentType === "CARD" ? "0px 6px 18px rgba(25, 118, 210, 0.18)" : "none",
          background: paymentType === "CARD" ? "#e3f2fd" : "#fff",
          color: COLORS.main,
          transition: "all 0.2s",
          scale: paymentType === "CARD" ? "1.1" : "0.9",
        }}
        onClick={() => setPaymentType("CARD")}
      >
        <FontAwesomeIcon icon={faCreditCard} style={{ fontSize: "20px", color: COLORS.main }} />
        <Typography style={{ fontWeight: "bold", fontSize: "15px" }}>
          {t("invoice.formValues.paymentType.CARD")}
        </Typography>
      </Card>
    </Box>
  );
};

export default SellingPaymentType;
